<template>
  <!-- 申请明细 -->
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">预约管理</div>
    </div>
    <el-divider></el-divider>
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label>
          <el-input
            v-model="filterForm.bookingNo"
            clearable
            placeholder="请输入预约编号"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            v-model="filterForm.coalMineName"
            clearable
            placeholder="请输入煤矿名称"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            v-model="filterForm.purchaseName"
            clearable
            placeholder="请输入采购方名称"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            v-model="filterForm.contactName"
            clearable
            placeholder="请输入联系人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-input
            v-model="filterForm.coalCategoryName"
            clearable
            placeholder="请输入煤种"
          ></el-input>
        </el-form-item>
        <el-form-item label>
          <el-select
            v-model="filterForm.status"
            clearable
            placeholder="请选择状态"
          >
            <el-option
              v-for="item in statusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label>
          <el-date-picker
            v-model="filterForm.createTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="计划创建开始时间"
            end-placeholder="计划创建开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            type="primary"
            @click="handlerSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            type="primary"
            @click="handleReset"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table
      :data="particularsList"
      v-loading="loading"
      stripe
      size="mini"
      style="width: 100%"
      row-key="id"
    >
      <el-table-column
        type="index"
        width="50"
        align="center"
        fixed
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="bookingNo"
        align="center"
        width="120"
        label="预约编号"
      ></el-table-column>
      <el-table-column
        prop="coalMineName"
        align="center"
        width="120"
        label="煤矿"
      ></el-table-column>
      <el-table-column
        prop="purchaseName"
        align="center"
        width="120"
        label="采购方"
      ></el-table-column>
      <el-table-column
        prop="lybCargoBillNo"
        align="center"
        width="120"
        label="陆运帮货单id"
      ></el-table-column>
      <el-table-column
        prop="contactName"
        align="center"
        min-width="100"
        label="联系人"
      ></el-table-column>
      <el-table-column
        prop="contactPhone"
        align="center"
        width="120"
        label="联系人电话"
      ></el-table-column>
      <el-table-column
        prop="coalCategoryName"
        align="center"
        width="120"
        label="煤种"
      ></el-table-column>
      <el-table-column
        prop="preLoadVal"
        align="center"
        width="150"
        label="采购方预载值"
      ></el-table-column>
      <el-table-column
        prop="openWaybillPrice"
        align="center"
        width="150"
        label="系统开单费"
      >
        <template slot-scope="scope">{{
          scope.row.openWaybillPrice ? scope.row.openWaybillPrice + "元" : 0
        }}</template>
      </el-table-column>
      <el-table-column
        prop="purchaseType"
        align="center"
        width="150"
        label="采购类型"
      >
        <template slot-scope="scope">
          {{
            scope.row.purchaseType && purchaseTypeList
              ? purchaseTypeList.find(
                  (item) => item.code === scope.row.purchaseType
                )["name"]
              : "自采"
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="dispatchSubjectNo"
        align="center"
        width="150"
        label="发运主体"
      >
        <template slot-scope="scope">
          <!-- {{scope.row.dispatchSubjectNo ? shippingSubjectObj[scope.row.dispatchSubjectNo] : '' }} -->
          {{
            scope.row.dispatchSubjectNo && shippingSubjectList
              ? shippingSubjectList.find(
                  (item) => item.codeStr === scope.row.dispatchSubjectNo
                )["name"]
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column
        prop="approvalType"
        align="center"
        width="180"
        label="审核方式"
      >
        <template slot-scope="scope">
          {{ scope.row.approvalType == 1 ? "人工审核" : "自动审核" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="acceptCompany"
        align="center"
        width="180"
        label="承运单位"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        align="center"
        width="180"
        label="计划创建时间"
      ></el-table-column>
      <el-table-column
        prop="bookingCarCount"
        align="center"
        width="120"
        label="预约车辆数（车）"
      ></el-table-column>
      <!-- <el-table-column prop="approvalCarCount" align="center" width="120" label="报名车辆数（车）"></el-table-column>
      <el-table-column prop="remainingCarCount" align="center" width="120" label="入场车辆数（车）"></el-table-column> -->
      <el-table-column fixed="right" align="center" label="操作" width="120">
        <template slot-scope="scope">
          <el-row
            ><kt-button
              label="添加发运主体"
              perms="30701"
              type="text"
              @click="addShippingSubject(scope.row)"
            ></kt-button
          ></el-row>
          <el-row
            ><kt-button
              label="添加采购类型"
              perms="30702"
              type="text"
              @click="addPurchaseType(scope.row)"
            ></kt-button
          ></el-row>
          <el-row
            ><kt-button
              label="开单费配置"
              perms="30912"
              type="text"
              @click="searchBookingId(scope.row)"
          /></el-row>
          <el-row
            ><kt-button
              label="合同号绑定"
              perms="60518"
              type="text"
              @click="bindContract(scope.row)"
          /></el-row>
          <el-row
            ><kt-button
              label="运费结算配置"
              perms="60519"
              type="text"
              @click="feeSettlement(scope.row)"
            ></kt-button
          ></el-row>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        prop="statusDesc"
        align="center"
        width="120"
        label="状态"
      ></el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right"
      ></el-pagination>
    </div>
    <!-- 开单费配置 -->
    <el-dialog
      title="开单费用配置"
      :visible.sync="showBillfee"
      :lock-scroll="true"
      :close-on-click-modal="false"
      @close="dialogCloseCallback"
      width="30%"
    >
      <div>
        <el-form
          :model="billfeeConfig"
          label-width="100px"
          :rules="billfeeForm"
          ref="billfeeForm"
          size="small"
        >
          <el-row :gutter="10">
            <el-col :span="18">
              <el-form-item label="预约单号：">
                <el-input v-model="bookingNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <!-- <kt-button
                v-if="!billfeeConfig.coalMineName"
                icon="fa fa-search"
                label="查找"
                perms="-1"
                type="primary"
                style="margin-top: 3px"
                @click="searchBookingId"
              /> -->
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="billfeeConfig.coalMineName">
            <el-col :span="18">
              <el-form-item label="煤矿名称：">
                <span>{{ billfeeConfig.coalMineName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="billfeeConfig.purchaseName">
            <el-col :span="18">
              <el-form-item label="采购方名称：">
                <span>{{ billfeeConfig.purchaseName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="billfeeConfig.bookingCarCount">
            <el-col :span="18">
              <el-form-item label="计划车辆数：">
                <span>{{ billfeeConfig.bookingCarCount }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-if="billfeeConfig.coalMineName">
            <el-col :span="18">
              <el-form-item label="开单费用：" prop="billfee">
                <el-input
                  v-model="billfeeConfig.billfee"
                  type="number"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
          v-if="billfeeConfig.coalMineName"
        >
          <el-button size="mini" @click="showBillfee = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="submitForm"
            >确 定</el-button
          >
        </span>
      </div>
    </el-dialog>
    <!-- 发运主体，采购类型 -->
    <el-dialog
      :title="configTitle"
      :visible.sync="showShippingSubject"
      :lock-scroll="true"
      :close-on-click-modal="false"
      width="30%"
      @close="closeShippingDialog"
    >
      <el-form label-width="100px" size="small">
        <el-form-item label="预约单号：">
          <el-input disabled v-model="bookingNo"></el-input>
        </el-form-item>
        <el-form-item label="发运主体：" v-if="configTitle === '发运主体配置'">
          <el-select
            v-model="shippingSubject"
            filterable
            clearable
            placeholder="请输入发运主体"
            
          >
            <el-option
              v-for="item in shippingSubjectList"
              :key="item.codeStr"
              :label="item.name"
              :value="item.codeStr"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购类型" v-if="configTitle === '采购类型配置'">
          <el-select
            v-model="purchaseType"
            filterable
            clearable
            placeholder="请选择采购类型"
          >
            <el-option
              v-for="item in purchaseTypeList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="showShippingSubject = false"
          >取 消</el-button
        >
        <el-button size="mini" type="primary" @click="submitShipping"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      width="40%"
      :visible.sync="showSettlement"
      @close="closeSettlementDialog"
      title="运费结算配置"
      :lock-scroll="true"
      :close-on-click-modal="false"
    >
      <el-form
        size="small"
        label-width="120px"
        :model="settleForm"
        ref="settleForm"
        :rules="ruleForm"
      >
        <el-form-item label="预约单号：">
          <el-input v-model="bookingNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="发运主体：" prop="lybOwnerUid">
          <el-select
            v-model="settleForm.lybOwnerUid"
            filterable
            clearable
            placeholder="请输入发运主体"
            @change="selectSubject"
            :disabled="isEdit"
            style="width:300px"
          >
            <el-option
              v-for="item in ownerList"
              :key="item.name"
              :label="item.name"
              :value="item.codeStr"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="发货地："
          v-if="showAddress"
          prop="loadingAddressId"
        >
          <el-select
            v-model="settleForm.loadingAddressId"
            filterable
            clearable
            placeholder="请选择发货地"
            :disabled="isEdit"
          >
            <el-option
              v-for="item in sendList"
              :key="item.id"
              :label="item.completeAddress"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="卸货地："
          v-if="showAddress"
          prop="unloadingAddressId"
        >
          <el-select
            v-model="settleForm.unloadingAddressId"
            filterable
            clearable
            placeholder="请选择卸货地"
            :disabled="isEdit"
          >
            <el-option
              v-for="item in receiveList"
              :key="item.id"
              :label="item.completeAddress"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运输单价：" prop="carriageUnitPrice">
          <el-input
            v-model="settleForm.carriageUnitPrice"
            clearable
            placeholder="请输入运价"
            type="number"
            class="mini-input"
          ></el-input
          >元/吨
        </el-form-item>
        <el-form-item label="煤种单价：" prop="coalCategoryUnitPrice">
          <el-input
            v-model="settleForm.coalCategoryUnitPrice"
            clearable
            placeholder="请输入煤种单价"
            type="number"
            class="mini-input"
          ></el-input>元/吨
        </el-form-item>
        <el-form-item label="运费核算吨位：" prop="tonSettleType">
          <el-radio-group v-model="settleForm.tonSettleType">
            <el-radio :label="1">装货吨位</el-radio>
            <el-radio :label="2">卸货吨位</el-radio>
            <el-radio :label="3">装、卸最小吨位</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="抹零方式：" prop="roundType">
          <el-radio-group v-model="settleForm.roundType">
            <el-radio
              v-for="item in roundTypeList"
              :key="item.codeStr"
              :label="item.codeStr"
              >{{ item.name }}</el-radio
            >
            <!-- <el-radio :label="1">小数抹零</el-radio>
              <el-radio :label="2">个位抹零</el-radio>
              <el-radio :label="3">不抹零</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="允许货损：" prop="allowGoodsDamage">
          <el-input
            v-model.number="settleForm.allowGoodsDamage"
            type="number"
            class="mini-input"
            clearable
            placeholder="请输入允许货损"
          ></el-input
          >KG
        </el-form-item>
        <el-form-item label="装货费用：" prop="loadingFee">
          <el-input
            v-model.number="settleForm.loadingFee"
            class="mini-input"
            type="number"
            clearable
            placeholder="请输入装货费用"
          ></el-input
          >元
        </el-form-item>
        <el-form-item label="卸货费用：" prop="unloadingFee">
          <el-input
            v-model.number="settleForm.unloadingFee"
            class="mini-input"
            type="number"
            clearable
            placeholder="请输入卸货费用"
          ></el-input
          >元
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="showSettlement = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitSettleForm"
          >保 存</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="合同编号绑定"
      :lock-scroll="true"
      :visible.sync="showBindDialog"
      :close-on-click-modal="false"
      width="500px"
      @close="clearForm"
    >
      <el-form :model="bindForm" label-width="130px" size="mini">
        <el-form-item label="预约单号：">
          <el-input
            v-model="bookingNo"
            disabled
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item label="采购合同编号：">
          <el-input
            v-model="contractId"
            placeholder="请输入采购合同编号"
            style="width: 200px"
            clearable
            :disabled="!!bindForm.contractId"
          ></el-input
          ><el-button
            style="margin-left: 10px"
            type="primary"
            size="mini"
            @click="searchContractId"
            v-if="!bindForm.contractId"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item label="煤种：" v-if="bindForm.contractId">
          <span>{{ bindForm.coalTypeName }}</span>
        </el-form-item>
        <el-form-item label="合同完成量/配额：" v-if="bindForm.contractId">
          <span
            >{{ bindForm.contractFinishedAmount }}/{{
              bindForm.contractTotal
            }}吨</span
          >
        </el-form-item>
        <el-form-item label="合同开始时间：" v-if="bindForm.contractId">
          <span>{{ bindForm.contractStartTime.replace(/T/g, " ") }}</span>
        </el-form-item>
        <el-form-item label="合同结束时间：" v-if="bindForm.contractId">
          <span>{{ bindForm.contractEndTime.replace(/T/g, " ") }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="showBindDialog = false">取 消</el-button>
        <el-button
          size="mini"
          type="primary"
          v-if="showBtn"
          @click="bindPurchaseId"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
import global from '@/utils/global.js'
import {ownerList} from '@/utils/instance.js'
let that = null;
const obj = {
  JBB: "靖边国兴丝路综合能源服务有限公司",
  BY: "八亿科技有限公司",
  BY_GYL: "八亿供应链有限公司",
  FY: "榆林市福运能源供应有限公司",
};

export default {
  components: {
    KtButton,
  },
  data() {
    return {
      size: "small",
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      loading: false,
      statusList: [],
      particularsList: [],
      ownerList,
      filterForm: {
        coalMineName: "",
        purchaseName: "",
        contactName: "",
        coalCategoryName: "",
        status: "",
        bookingDate: "",
      },
      showBillfee: false,
      bookingNo: "",
      billfeeConfig: {
        billfee: null,
      },
      configTitle: "",
      showShippingSubject: false,
      shippingSubject: "",
      // shippingSubjectObj:obj,
      shippingSubjectList: [],
      purchaseType: null,
      purchaseTypeList: [],
      showAddress: false,
      showSettlement: false,
      settleForm: {
        lybOwnerUid: "",
        loadingAddressId: "",
        unloadingAddressId: "",
        tonSettleType: "",
        roundType: "",
        coalCategoryUnitPrice: 0,
        allowGoodsDamage: 0,
        loadingFee: 0,
        unloadingFee: 0,
      },
      isEdit: false,
      receiveList: [],
      sendList: [],
      roundTypeList: [],
      billfeeForm: {
        billfee: [
          {
            required: true,
            validator: this.checkoutBillfee(),
          },
        ],
      },
      ruleForm: {
        lybOwnerUid: [{ required: true, message: "请选择发运主体" }],
        loadingAddressId: [{ required: true, message: "请选择发货地" }],
        carriageUnitPrice: [{ required: true, message: "请输入运价" ,validator:this.checkAllowsGoodsDamage('carriageUnitPrice')}],
        coalCategoryUnitPrice: [{ required: true, message: "请输入煤种单价" ,validator:this.checkAllowsGoodsDamage('coalCategoryUnitPrice') }],
        unloadingAddressId: [{ required: true, message: "请选择卸货地" , }],
        tonSettleType: [{ required: true, message: "请选择运单核算吨位" }],
        roundType: [{ required: true, message: "请选择抹零方式" }],
        allowGoodsDamage: [
          { required: true, validator: this.checkAllowsGoodsDamage('allowGoodsDamage') },
        ],
        loadingFee: [{ required: true, message: "请输入装货费用" ,validator:this.checkAllowsGoodsDamage('loadingFee')}],
        unloadingFee: [{ required: true, message: "请输入卸货费用",validator:this.checkAllowsGoodsDamage('unloadingFee') }],
      },
      showBindDialog: false,
      bindForm: {},
      contractId: "",
      showBtn: true,
    };
  },
  computed: {},
  mounted() {
    this.getStatusList();
    this.getShippingList();
    this.getPurchaseTypeList();
    this.getParticularsList();
    if(global.mode==='develop'){
      this.getOwnerList();
    }
  },
  methods: {
    // 获取状态列表
    getStatusList() {
      this.$api.apply.mGetStatusList().then((res) => {
        if (res.data && res.data.length > 0) {
          this.statusList = res.data;
        } else {
          this.statusList = [];
        }
      });
    },

    // 获取采购方列表
    async getParticularsList() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "createTime") {
            params[
              "searchFieldList[" + index + "].rangeMinValue"
            ] = `${val[0]} 00:00:00`;
            params[
              "searchFieldList[" + index + "].rangeMaxValue"
            ] = `${val[1]} 23:59:59`;
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.apply.mGetBookingList(params);
      this.totalSize = res.data.totalSize || 0;
      if (res.data && res.data.dtoList && res.data.dtoList.length > 0) {
        this.particularsList = res.data.dtoList;
      } else {
        this.particularsList = [];
      }
      this.loading = false;
    },
    //校验开单金额
    checkoutBillfee() {
      return (rule, value, callback) => {
        if (!value) {
          return callback(new Error("请输入开单费用"));
        }
        if (value < 0 || value == 0) {
          return callback(new Error("请输入大于0的数字"));
        }
        this.billfeeConfig.billfee = value.match(/^\d*(\.?\d{0,2})/g)[0];
        return callback();
      };
    },
    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getParticularsList();
    },
    //筛选预约单
    searchBookingId(row) {
      // if(!this.bookingNo){
      //   this.$message({
      //     type:'error',
      //     message:'请先填写预约单号',
      //     offset: 300
      //   })
      //   return
      // }
      this.$api.apply
        .checkBookingNo({
          bookingNo: row.bookingNo,
        })
        .then((res) => {
          // this.searchBookingNo()
          this.bookingNo = row.bookingNo;
          this.billfeeConfig = row;
          this.showBillfee = true;
        });
      //调下查的接口 数据放在billfeeConfig
    },
    searchBookingNo() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      params["searchFieldList[0].fieldName"] = "bookingNo";
      (params["searchFieldList[0].singleValue"] = this.bookingNo),
        this.$api.apply.mGetBookingList(params).then((res) => {
          this.billfeeConfig = res.data.dtoList[0];
        });
    },
    checkAllowsGoodsDamage(key) {
      return (rule, value, callback) => {
        if (value!==0 &&!value) {
          return callback(new Error("请输入允许货损"));
        }
        this.settleForm[key] = (value + "").match(
          /^\d*(\.?\d{0,2})/g
        )[0];
        return callback();
      };
    },
    //处理dialog状态改变内部数据
    dialogCloseCallback() {
      this.billfeeConfig = {};
      this.bookingNo = "";
    },
    // 搜索
    handlerSearch() {
      this.pageNo = 1;
      this.getParticularsList();
    },
    submitForm() {
      this.$refs["billfeeForm"].validate((valid) => {
        if (valid) {
          let { billfee } = this.billfeeConfig;
          this.$confirm(
            `请确认是否要把预约单${this.bookingNo}设置为开单费${billfee}元`
          )
            .then((val) => {
              this.$api.apply
                .setBillfee({
                  bookingNo: this.bookingNo,
                  openWaybillPrice: billfee,
                })
                .then((res) => {
                  this.$message({
                    type: "success",
                    message: "设置成功",
                  });
                  this.showBillfee = false;
                  this.dialogCloseCallback();
                  this.getParticularsList();
                });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    //   重置
    handleReset() {
      this.filterForm = {
        coalMineName: "",
        purchaseName: "",
        contactName: "",
        coalCategoryName: "",
        status: "",
        bookingDate: "",
      };
      this.handlerSearch();
    },
    //发运主体
    addShippingSubject(row) {
      this.bookingNo = row.bookingNo;
      this.shippingSubject = row.dispatchSubjectNo;
      this.configTitle = "发运主体配置";
      // this.getShippingList()
      this.showShippingSubject = true;
    },
    getShippingList() {
      this.$api.apply.mGetDispatchSubjectList({}).then((res) => {
        this.shippingSubjectList = res.data;
      });
    },
    //采购类型
    addPurchaseType(row) {
      this.bookingNo = row.bookingNo;
      this.configTitle = "采购类型配置";
      this.purchaseType = row.purchaseType;
      // this.getPurchaseTypeList()
      this.showShippingSubject = true;
    },
    getPurchaseTypeList() {
      this.$api.apply.mGetPurchaseTypeList({}).then((res) => {
        this.purchaseTypeList = res.data;
      });
      // this.purchaseTypeList = [{id:1,name:'自采'},{id:2,name:'代采'},{id:3,name:'公转铁'},{id:4,name:'保供'}]
    },
    submitShipping() {
      let title = this.configTitle;
      if (
        title === "发运主体配置"
          ? !this.shippingSubject
          : !this.purchaseType && this.purchaseType !== 0
      ) {
        this.$message({
          type: "error",
          message: `请选择${
            title === "发运主体配置" ? "发运主体" : "采购类型"
          }`,
          offset: 300,
        });
        return;
      }
      title === "发运主体配置"
        ? this.$api.apply
            .setDispatchSubject({
              bookingNo: this.bookingNo,
              dispatchSubjectNo: this.shippingSubject,
              dispatchSubjectName: this.shippingSubjectList.find((item) => {
                return item.codeStr === this.shippingSubject;
              }).name,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "配置成功",
                offset: 300,
              });
              this.getParticularsList();
              this.showShippingSubject = false;
              return;
            })
        : this.$api.apply
            .setPurchaseType({
              bookingNo: this.bookingNo,
              purchaseType: this.purchaseType,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "配置成功",
                offset: 300,
              });
              this.getParticularsList();
              this.showShippingSubject = false;
            });
    },
    closeShippingDialog() {
      this.shippingSubject = "";
      this.purchaseType = "";
    },
    async feeSettlement(row) {
      (this.settleForm = {
        lybOwnerUid: "",
        loadingAddressId: "",
        unloadingAddressId: "",
        tonSettleType: "",
        roundType: "",
        carriageUnitPrice: row.transportPrice || 0,
        coalCategoryUnitPrice: 0,
        allowGoodsDamage: row.allowGoodsDemage || 0,
        loadingFee: 0,
        unloadingFee: 0,
      }),
        (this.bookingNo = row.bookingNo);
      let result = await this.$api.apply.mGetRoundTypeList();
      result.data.forEach((item) => {
        item.codeStr = Number(item.codeStr);
      });
      this.roundTypeList = result.data;
      let res = await this.$api.apply.getWaybillFeeConfig({
        bookingNo: this.bookingNo,
      });
      if (res.data) {
        this.settleForm = Object.assign({}, res.data);
        this.showAddress = true;
        this.isEdit = true;
        await this.selectSubject(res.data.lybOwnerUid, "noselect");
      }
      this.showSettlement = true;
    },
    selectSubject(val, type) {
      this.showAddress = !!val;
      if (!type) {
        this.settleForm.loadingAddressId = "";
        this.settleForm.unloadingAddressId = "";
      }
      this.$api.apply
        .mGetAddressList({
          lybOwnerUid: val,
        })
        .then((res) => {
          if (!res.data.send) {
            this.sendList = [];
            this.receiveList = [];
            return;
          }
          res.data.send.forEach((item) => {
            item.id = Number(item.id);
          });
          res.data.receive.forEach((item) => {
            item.id = Number(item.id);
          });
          this.sendList = res.data.send;
          this.receiveList = res.data.receive;
        });
    },
    submitSettleForm() {
      this.$refs.settleForm.validate((valid) => {
        if (valid) {
          let loadingAddress = this.ownerList.length
            ? this.sendList.find((item) => {
                return item.id == this.settleForm.loadingAddressId;
              })["completeAddress"]
            : "";
          let unloadingAddress = this.receiveList.length
            ? this.receiveList.find((item) => {
                return item.id == this.settleForm.unloadingAddressId;
              })["completeAddress"]
            : "";
          this.$api.apply
            .setWaybillFeeConfig({
              bookingNo: this.bookingNo,
              dispatchSubject: this.ownerList.find((item) => {
                return item.codeStr === this.settleForm.lybOwnerUid;
              })["name"],
              loadingAddress,
              unloadingAddress,
              ...this.settleForm,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "设置成功",
                offset: 300,
              });
              this.showSettlement = false;
              this.sendList = this.getParticularsList();
            });
        }
      });
    },
    closeSettlementDialog() {
      this.showAddress = false;
      this.isEdit = false;
      // this.sendList = []
      // this.receiveList = []
      this.$refs["settleForm"].resetFields();
      this.settleForm = {
        lybOwnerUid: "",
        loadingAddressId: "",
        unloadingAddressId: "",
        tonSettleType: "",
        roundType: "",
        coalCategoryUnitPrice: 0,
        allowGoodsDamage: 0,
        loadingFee: 0,
        unloadingFee: 0,
      };
      // this.settleForm = {}
    },
    getOwnerList() {
      this.$api.apply.mGetOwnerList({}).then((res) => {
        this.ownerList = res.data;
      });
    },
    async bindContract(row) {
      this.bookingNo = row.bookingNo;
      // 根据列表数据判断绑定状态 或者请求接口 处理bindform
      if (row.gtContractId) {
        this.contractId = row.gtContractId;
        this.showBtn = false;
        await this.searchContractId();
      }
      this.showBindDialog = true;
    },
    clearForm() {
      this.bindForm = {};
      this.contractId = "";
      this.showBtn = true;
    },
    bindPurchaseId() {
      if (!this.contractId || !this.bindForm.contractId) {
        this.$message({
          type: "error",
          message: `${
            !this.contractId ? "请填写合同编号" : "请先筛选对应合同"
          }`,
          offset: 300,
        });
        return;
      }
      this.$api.apply
        .bindContract({
          bookingNo: this.bookingNo,
          ...this.bindForm,
        })
        .then((res) => {
          this.getParticularsList();
          this.showBindDialog = false;
        });
    },
    async searchContractId() {
      if (!this.contractId) {
        this.$message({
          type: "error",
          message: "请输入采购合同编号",
          offset: 300,
        });
        return;
      }
      let res = await this.$api.apply.searchContractInfo({
        contractId: this.contractId,
      });
      this.bindForm = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 10px 30px;
}

.addressMap {
  width: 100%;
  height: 200px;
  margin-top: 20px;
}
.mini-input {
  width: 150px;
}
// ::v-deep .el-button{
//   margin: 0;
// }
</style>
